import { HeatMap } from "../heat_map_row/heat_map_item.types";

export const groupItemsByAvailability = (heatMapItems: HeatMap[]): HeatMap[][] =>
  heatMapItems.reduce<HeatMap[][]>((groupedItems, current, index) => {
    if (current.available_minutes === heatMapItems[index - 1]?.available_minutes) {
      groupedItems[groupedItems.length - 1].push(current);
    } else {
      groupedItems.push([current]);
    }
    return groupedItems;
  }, []);
